export const MODAL_OPEN = "MODAL_OPEN"


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js